export default __webpack_public_path__ + "static/media/bgimage.de861499.jpg";